import { ActionTypes, State } from './types';
import { createEmptyQuestion, filterOutAnswer } from './utils';

const initialState: State = {
  editedQuestionId: null,
  questions: [],
  initialQuestions: [],
  blockingAnswers: [],
  currentSection: 1,
};

const questionnaireReducer = (state: State = initialState, action: any): State => {
  switch (action.type) {
    case ActionTypes.SET_EDITED_QUESTION_ID:
      return {
        ...state,
        editedQuestionId: action.payload
      };

    case ActionTypes.SET_QUESTIONS:
      return {
        ...state,
        questions: action.payload
      };

    case ActionTypes.ADD_EMPTY_QUESTION:
      return {
        ...state,
        questions: [...state.questions, createEmptyQuestion(state.currentSection)]
      };

    case ActionTypes.ADD_EMPTY_QUESTION_TO_SECTION:
      return {
        ...state,
        questions: [...state.questions, createEmptyQuestion(action.payload)]
      };

    case ActionTypes.SET_CURRENT_SECTION:
      return {
        ...state,
        currentSection: action.payload
      };

    case ActionTypes.SET_INITIAL_QUESTIONS:
      return {
        ...state,
        questions: action.payload,
        initialQuestions: action.payload,
      };

    case ActionTypes.ADD_BLOCKING_ANSWER:
      return {
        ...state,
        blockingAnswers: [...state.blockingAnswers, action.payload]
      };

    case ActionTypes.REMOVE_BLOCKING_ANSWER:
      return {
        ...state,
        blockingAnswers: filterOutAnswer(state.blockingAnswers, action.payload),
      };

    case ActionTypes.SET_BLOCKING_ANSWERS:
      return {
        ...state,
        blockingAnswers: action.payload
      };

    default:
      return state;
  }
};

export default questionnaireReducer;
